import { Button, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import { DataMap, enums } from "../../base";
import { CpCheckModel } from "../../models";

export interface CpCheckToolbarProps {
    permissions: DataMap<boolean>;
    onButtonClick: (model: CpCheckModel, name: string) => void;
    onContextButtonClick: (ids: number[], name: string) => void;
}

interface CpCheckToolbarState {
    model: CpCheckModel;
    ids: number[];
}

export default class CpCheckToolbar extends React.Component<CpCheckToolbarProps, CpCheckToolbarState> {
    constructor(props: Readonly<CpCheckToolbarProps>) {
        super(props);

        this.state = {
            model: {},
            ids: []
        }
    }

    setModel(model: CpCheckModel) {
        this.setState({ model: model });
    }

    setIds(ids: number[]) {
        this.setState({ ids: ids });
    }

    render(): React.ReactNode {
        const { model, ids } = this.state;
        const permissions = this.props.permissions || {};

        return (
            <div className={"page-toolbar"}>
                <Toolbar>
                    <Item location={"after"} locateInMenu={"auto"} visible={!!permissions[enums.stdActions.create]}>
                        <Button
                            text="新增"
                            onClick={() => this.props.onButtonClick({}, "add")} />
                    </Item>
                    <Item location={"after"} locateInMenu="auto" visible={!!permissions[enums.stdActions.update]}>
                        <Button
                            disabled={!model.id}
                            text="编辑"
                            onClick={() => this.props.onButtonClick(model, "edit")} />
                    </Item>
                    <Item location={"after"} locateInMenu="auto" visible={!!permissions[enums.stdActions.delete]}>
                        <Button
                            disabled={!ids.length}
                            text="批量删除"
                            onClick={() => this.props.onContextButtonClick(ids, "delete")} />
                    </Item>
                </Toolbar>
            </div>
        );
    }
}